export default __webpack_public_path__ + "static/Jorge-1e0319a879697a7a45546675c095037b.jpg";